<ng-container *ngIf="loading && items.length == 0">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>

<div class="list">
     <ion-searchbar *ngIf="items.length > 5 || searchTerm"
                    [placeholder]="'ATTENDEE_LIST_SEARCH_PLACEHOLDER' | translate"
                    class="without-border"
                    style="padding: 0;"
                    [debounce]="500"
                    enterkeyhint="search"
                    [(ngModel)]="searchTerm"
                    (onenter)="refresh()"
                    (ionChange)="refresh(null, true)">
     </ion-searchbar>

    <div *ngFor="let item of items; let c = index"
         class="participant">
        <ion-avatar (click)="showAttendeeDetail(item)">
            <img class="avatar"
                 img-avatar
                 [src]="user?.canPicture(item) ? item.picture_url : ''"
                 alt="">
        </ion-avatar>

        <div class="detail">
            <h3 (click)="showAttendeeDetail(item)">{{ item.firstname }} {{ item.lastname }}</h3>
        </div>
    </div>
</div>
